import { createFileRoute } from '@tanstack/react-router'

import { ProfileVerificationPage } from '@/pages/profile-verification'

export const Route = createFileRoute('/profile/verification/$token')({
  component: RouteComponent,
})

export const ProfileVerificationRoute = Route

function RouteComponent() {
  const { token } = Route.useParams()
  return <ProfileVerificationPage token={token} />
}
